import React, { useState, useEffect, useMemo, Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { YMaps, Map, Placemark } from '@pbe/react-yandex-maps';
import { Modal } from 'react-bootstrap'
import { notify } from 'helpers/helpers';
import { httpOk, GET } from 'helpers/api';
import {
	countCourierOrders,
	courierPlacemarkOptions,
	courierPlacemarkProperties,
	posPlacemarkOptions,
	posPlacemarkProperties,
	clientPlacemarkProperties,
} from 'helpers/mapPlacemark';

function Index({ data, poses, modal, toggleModal, liveCourierLocations }) {
	const { t } = useTranslation()
	const reduxAccount = useSelector(state => state.account)

	const [mapState, setMapState] = useState({
		center: [],
		zoom: 13,
		controls: ["zoomControl"]
	});
	const [modalMap, setModalMap] = useState(false)
	const [couriers, setCouriers] = useState([])

	function toggleModalMap(bool = false) {
		setModalMap(bool)
		if (!bool) toggleModal(bool, 'map')
	}

	function calculateCenter() {
		// Преобразуем координаты в числа
		const coordinates = data
			.map(item => {
				const lat = parseFloat(item.client_latitude);
				const lon = parseFloat(item.client_longitude);
				if (!isNaN(lat) && !isNaN(lon)) {
					return [lat, lon];
				}
				return null;
			})
			.filter(coord => coord !== null);

		if (coordinates.length === 0 && poses.length === 0) {
			notify(t('no_orders_with_coordinates'))
			return;
		}

		if (coordinates.length === 0) {
			setMapState(prev => ({
				...prev,
				center: [poses[0]['latitude'], poses[0]['longitude']]
			}));
			setModalMap(modal.map)
			return;
		}

		const avgLat = coordinates.reduce((sum, coord) => sum + coord[0], 0) / coordinates.length;
		const avgLon = coordinates.reduce((sum, coord) => sum + coord[1], 0) / coordinates.length;

		setMapState(prev => ({
			...prev,
			center: [avgLat, avgLon]
		}));
		setModalMap(modal.map)
	}

	async function getCouriers() {
		const response = await GET('/delivery/couriers-locations')
		if (httpOk(response)) setCouriers(response.data ?? [])
	}

	// Позиция из сокета свежее той, что приехала GET-ом при открытии карты.
	const couriersOnMap = useMemo(() => {
		return couriers.map((courier) => {
			const live = liveCourierLocations?.[courier.user_id]
			return {
				...courier,
				latitude: live?.latitude ?? courier.latitude,
				longitude: live?.longitude ?? courier.longitude,
				updated_at: live?.updated_at ?? courier.updated_at,
				count: countCourierOrders(data, courier.user_id),
			}
		})
	}, [couriers, liveCourierLocations, data])

	useEffect(() => {
		if (modal.map) calculateCenter()

	}, [data, modal]); // eslint-disable-line react-hooks/exhaustive-deps

	// Только на открытие карты: заказы прилетают сокетом пачками, тянуть за каждым
	// из них ещё и позиции курьеров незачем — их дальше двигает тот же сокет.
	useEffect(() => {
		if (modal.map) getCouriers()

	}, [modal.map]); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			{/* MODAL UPDATE CLIENT */}
			<Modal show={modalMap} animation={false} centered size="xl"
				onHide={() => toggleModalMap()}>
				<Modal.Body>
					<div style={{ 'height': '700px', 'width': '100%' }}>
						<YMaps
							style={{ 'height': '700px', 'width': '100%' }}
							query={{
								load: "package.full",
								apikey: `${reduxAccount.map_token}`
							}}>
							<Map
								state={mapState}
								defaultOptions={{
									copyrightUaVisible: false,
									yandexMapDisablePoiInteractivity: true,
								}}
								style={{ 'height': '700px', 'width': '100%' }}>
								{poses?.map((item, index) => (
									<Fragment key={index}>
										{item.latitude &&
											<Placemark key={index}
												geometry={[item.latitude, item.longitude]}
												options={posPlacemarkOptions}
												properties={posPlacemarkProperties({
													name: item.name,
													phone: item.phone,
													count: item.count,
													t: t,
												})}
											/>
										}
									</Fragment>
								))}
								{couriersOnMap?.map((item) => (
									<Fragment key={`courier-${item.user_id}`}>
										{item.latitude &&
											<Placemark
												geometry={[item.latitude, item.longitude]}
												options={courierPlacemarkOptions}
												properties={courierPlacemarkProperties({
													name: item.name,
													phone: item.phone,
													count: item.count,
													updatedAt: item.updated_at,
													t: t,
												})}
											/>
										}
									</Fragment>
								))}
								{data?.map((item, index) => (
									<Fragment key={index}>
										{item.client_latitude &&
											<Placemark key={index} geometry={[item.client_latitude, item.client_longitude]}
												properties={clientPlacemarkProperties({
													name: item.client_name,
													phone: item.client_phone,
													orderId: item.id,
													t: t,
												})}
											/>
										}
									</Fragment>
								))}
							</Map>
						</YMaps>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL UPDATE CLIENT */}
		</>
	)
}

export default Index